import React from "react";
import InputControls from "../../common/InputControls";
import { ActionSpecifDetail as ActionDetails } from "../../../../configurations/discoverConfigs/actionCodes";

class ActionSpecificDetail extends React.Component {
  render() {
    const {
      transactionDetails,
      caseDetails,
      selectedActionCode,
      formData
    } = this.props;
    return (
      <div>
        {ActionDetails[selectedActionCode] &&
          ActionDetails[selectedActionCode].fields && (
            <div className="panel panel-default">
              <div className="panel-body">
                <div id="reason-specific-detail">
                  <h5 className="bold">
                    Action: {ActionDetails[selectedActionCode].description}
                  </h5>
                  {ActionDetails[selectedActionCode].fields.map(
                    (field, index) =>
                      field && (
                        <InputControls
                          key={index}
                          transactionDetails={transactionDetails || caseDetails}
                          field={field}
                          formData={formData}
                          selectedCode={selectedActionCode}
                        />
                      )
                  )}
                </div>
              </div>
            </div>
          )}
      </div>
    );
  }
}

export default ActionSpecificDetail;



// WEBPACK FOOTER //
// ./src/components/discover/cases/caseDetail/ActionSpecificDetail.js